import { useMemo } from 'react';

import { useIsConfigureTenantEnabled } from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useConfigureTenantAdminPageSettings: UseMainUIFeatureSettings<'configureTenantAdminPage'> = (options) => {
  const configureTenantPageOverrides = options?.overrides?.configureTenantAdminPage;

  const isConfigureTenantEnabled = useIsConfigureTenantEnabled();

  return useMemo(
    () => ({
      [uiFeatureAccessSymbol]: isConfigureTenantEnabled,
      ...configureTenantPageOverrides,
    }),
    [configureTenantPageOverrides, isConfigureTenantEnabled]
  );
};
